import { useLocation, useNavigate } from "react-router-dom";
import { AuthComp } from "../../../auth/AuthComp";
import { LOGIN, MODIFICAINDIRIZZOSPEDIZIONE } from "../../../global/urlMapping";
import { Redirect } from "../../tools/Redirect";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkScreeningCLSelector } from "../../../modules/screeningColonRetto/selectors";
import { Box, Button, CircularProgress, Divider, Grid, Paper, Typography } from "@mui/material";

import { ReactComponent as HomeIcona } from "../../../resources/icone/Home.svg";
import { ReactComponent as CittàIcona } from "../../../resources/icone/Citt.svg";
import { ReactComponent as TelefonoIcona } from "../../../resources/icone/Phone.svg";
import { ReactComponent as MailIcona } from "../../../resources/icone/Mail.svg";
import { profiloAriannaSelector } from "../../../modules/screening/selectors";
import { ricercaComuniSelector } from "../../../modules/anagrafe/selectors";
import { postAdhesionCLAction } from "../../../modules/screeningColonRetto/actions";
import { postAppointmentConfirmAction } from "../../../modules/screening/actions";
import { isNotNullUndefined } from "../../../functions/inputValidation";
import { setMessaggioAction } from "../../../modules/messaggio/actions";
import { ERRORE_CUSTOM } from "../../../global/messaggioLabels";
import { DomicilioAttivoAsl } from "../../multiAslComponent/DomicilioAttivoAsl";

export const RiceviADomicilio = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const checkScreeningCL = useSelector(checkScreeningCLSelector)
    const profiloArianna = useSelector(profiloAriannaSelector)
    const ricercaComuni = useSelector(ricercaComuniSelector)

    const invite = location?.state?.invite;

    const isHidden = (invite === undefined || invite === null) && checkScreeningCL?.status !== 200;

    const onClickConferma = () => {
        //controllo che l'indirizzo non sia vuoto, altrimenti mostro una modale
        if (!isNotNullUndefined(profiloArianna?.value?.patient?.screeningAddress).error &&
            !isNotNullUndefined(profiloArianna?.value?.patient?.screeningMunicipalityCode).error &&
            !isNotNullUndefined(profiloArianna?.value?.patient?.screeningZipCode).error &&
            !isNotNullUndefined(profiloArianna?.value?.patient?.personalMobile).error
        ) {
            //Uguale alla modale di ADESIONECL
            if (checkScreeningCL?.status === 200)//se è candidatura spontanea
                dispatch(postAdhesionCLAction("SHIPPED"));
            else {
                dispatch(postAppointmentConfirmAction({
                    "idAppointment": invite?.id,
                    "withdrawalMethod": "SHIPPED"
                }))
            }
        } else {
            dispatch(setMessaggioAction({
                status: ERRORE_CUSTOM, value:
                {
                    titolo: 'Attenzione',
                    sottotitolo: 'Per procedere con la conferma è necessario inserire le informazioni relative a indirizzo, cap, comune e telefono.',
                    label: 'OK',
                    primaryColor: '#D1AE00', //giallo
                    secondaryColor: '#FFF2B4', //giallo chiaro
                    onClickLink: () => { navigate(MODIFICAINDIRIZZOSPEDIZIONE, { state: { invite } }); },
                }
            }))
        }
    }
    useEffect(() => {
        if (isHidden)
            navigate(-1)
    }, [isHidden, navigate])
    useEffect(() => {
        window.scrollTo(0, 0)

    }, [])

    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <DomicilioAttivoAsl  >
                {
                    isHidden && <CircularProgress sx={{ margin: "10% auto", display: 'flex', alignItems: "center" }} />
                }
                {
                    !isHidden &&
                    <Box className="emptyBg" sx={{
                        flexGrow: 1,
                        overflow: 'hidden',
                        with: "100%"
                    }}>
                        <Box sx={{ x: 'auto' }}>
                            <Grid container wrap="nowrap" spacing={2}>
                                <Grid item xs zeroMinWidth>

                                    <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                        <Typography
                                            component='h1'
                                            sx={{
                                                color: "#005397",
                                                margin: "auto",
                                                textAlign: "center",
                                                fontSize: { xs: "25px", md: "40px" },
                                                fontWeight: 700,
                                            }}
                                        >
                                            Ricevi kit ed esito presso la tua residenza o tuo
                                            domicilio
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        <>
                            <Box sx={{ my: 4, mx: 'auto' }}>
                                <Grid container wrap="nowrap" spacing={2}>
                                    <Grid item xs zeroMinWidth>
                                        <Box
                                            sx={{
                                                width: "80%",
                                                margin: "auto",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Paper
                                                elevation={6}
                                                sx={{
                                                    minHeight: "150px",
                                                    borderRadius: "20px",
                                                    textDecoration: "none !important",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: { xs: "100%", md: "70%" },
                                                    padding: "0px",
                                                    margin: "auto",
                                                }}
                                            >
                                                <Typography
                                                    component='h2'
                                                    sx={{
                                                        fontSize: "25px",
                                                        fontWeight: 700,
                                                        color: "#005397",
                                                        margin: "25px auto",
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    Indirizzo
                                                </Typography>

                                                <Divider variant="middle" sx={{ backgroundColor: "#999999", opacity: '30%', width: '40%', margin: '0 auto' }} />
                                                <Grid container sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '400px', margin: 'auto 25px', backgroundColor: 'transparent' }}>
                                                    <Grid item sx={{ minHeight: '80px', width: { xs: '100%', md: '80%' }, display: 'flex', flexDirection: 'row', margin: '25px auto', backgroundColor: 'transparent' }}>
                                                        <Box sx={{ display: 'flex', width: { xs: '80px', md: '150px' }, backgroundColor: 'transparent' }}>
                                                            <HomeIcona style={{ margin: 'auto', height: '60px' }} />
                                                        </Box>
                                                        <Box sx={{ minHeight: '80px', display: 'flex', flexDirection: 'column', marginLeft: '10px', justifyContent: 'flex-start' }}>
                                                            <Typography sx={{ color: '#005397', fontWeight: 300, fontSize: { xs: '20px', md: '25px' }, backgroundColor: 'transparent' }} component='h3'>
                                                                Indirizzo
                                                            </Typography>
                                                            <Typography sx={{ color: 'black', fontWeight: 200, fontSize: { xs: '16px', md: '20px' } }}>
                                                                {profiloArianna?.value?.patient?.screeningAddress}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item sx={{ minHeight: '80px', width: { xs: '100%', md: '80%' }, display: 'flex', margin: '25px auto', backgroundColor: 'transparent' }}>
                                                        <Box sx={{ display: 'flex', width: { xs: '80px', md: '150px' }, backgroundColor: 'transparent', justifyContent: 'flex-start' }}>
                                                            <CittàIcona style={{ margin: 'auto', height: '60px' }} />
                                                        </Box>
                                                        <Box sx={{ minHeight: '80px', display: 'flex', flexDirection: 'column', marginLeft: '10px', justifyContent: 'flex-start' }}>
                                                            <Typography sx={{ color: '#005397', fontWeight: 300, fontSize: { xs: '20px', md: '25px' }, backgroundColor: 'transparent' }} component='h3'>
                                                                Città
                                                            </Typography>
                                                            <Typography sx={{ color: 'black', fontWeight: 200, fontSize: { xs: '20px', md: '20px' } }}>
                                                                {ricercaComuni?.value?.Comuni?.find(element => element.CodIstat.includes(profiloArianna?.value?.patient?.screeningMunicipalityCode))?.NomeComune}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item sx={{ minHeight: '80px', width: { xs: '100%', md: '80%' }, display: 'flex', margin: '25px auto', backgroundColor: 'transparent' }}>
                                                        <Box sx={{ display: 'flex', width: { xs: '80px', md: '150px' }, backgroundColor: 'transparent' }}>
                                                            <TelefonoIcona style={{ margin: 'auto', height: '60px' }} />
                                                        </Box>
                                                        <Box sx={{ minHeight: '80px', display: 'flex', flexDirection: 'column', marginLeft: '10px', justifyContent: 'flex-start' }}>
                                                            <Typography sx={{ color: '#005397', fontWeight: 300, fontSize: { xs: '20px', md: '25px' }, backgroundColor: 'transparent' }} component='h3'>
                                                                Telefono
                                                            </Typography>
                                                            <Typography sx={{ color: 'black', fontWeight: 200, fontSize: '20px' }}>
                                                                {profiloArianna?.value?.patient?.personalMobile}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item sx={{ minHeight: '80px', width: { xs: '100%', md: '80%' }, display: 'flex', margin: '25px auto', backgroundColor: 'transparent' }}>
                                                        <Box sx={{ display: 'flex', width: { xs: '80px', md: '150px' }, backgroundColor: 'transparent' }}>
                                                            <MailIcona style={{ margin: 'auto', width: '70px' }} />
                                                        </Box>
                                                        <Box sx={{ minHeight: '80px', display: 'flex', flexDirection: 'column', marginLeft: '10px', justifyContent: 'flex-start' }}>
                                                            <Typography sx={{ color: '#005397', fontWeight: 300, fontSize: { xs: '20px', md: '25px' }, backgroundColor: 'transparent' }} component='h3'>
                                                                Mail
                                                            </Typography>
                                                            <Typography sx={{ color: 'black', fontWeight: 200, fontSize: '20px' }}>
                                                                {profiloArianna?.value?.patient?.personalEmail}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>


                            <Box sx={{ width: "100%", display: "flex", paddingTop: "10px", paddingBottom: "20px" }}>
                                <Button
                                    onClick={() => {
                                        onClickConferma();
                                    }}
                                    variant="contained"
                                    disableRipple
                                    disableFocusRipple
                                    disableTouchRipple
                                    sx={{
                                        backgroundColor: "#005397",
                                        margin: "auto",
                                        height: "50px",
                                        width: "70%",
                                        borderRadius: "20px !important",
                                        color: "white",
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                    }}
                                >
                                    Conferma adesione

                                </Button>
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", paddingTop: "10px", paddingBottom: "20px" }}>
                                <Button
                                    onClick={() => {
                                        navigate(MODIFICAINDIRIZZOSPEDIZIONE, { state: { invite } });
                                    }}
                                    variant="contained"
                                    disableRipple
                                    disableFocusRipple
                                    disableTouchRipple
                                    sx={{
                                        backgroundColor: "#FFFFFF",
                                        margin: "auto",
                                        height: "50px",
                                        width: "70%",
                                        borderRadius: "20px !important",
                                        color: "#005397",
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                    }}
                                >
                                    Modifica

                                </Button>
                            </Box>

                        </>
                    </Box>
                }
            </DomicilioAttivoAsl>
        </AuthComp>
    );
}